var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBolotas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 120,
    viewBox: "0 0 1058 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_242_1445",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1058,
    height: 146
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1058,
    height: 146,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_242_1445)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.409467,
    y: -0.409467,
    width: 45.1811,
    height: 45.176,
    rx: 22.588,
    transform: "matrix(1 2.22734e-09 2.22734e-09 -1 995 106.176)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.409467,
    y: -0.409467,
    width: 93.0406,
    height: 45.176,
    rx: 22.588,
    transform: "matrix(1 2.22734e-09 2.22734e-09 -1 946.558 45.2953)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.409467,
    y: -0.409467,
    width: 93.0406,
    height: 45.176,
    rx: 22.588,
    transform: "matrix(1 2.22734e-09 2.22734e-09 -1 666.559 94.2953)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.625772,
    y: 0.625772,
    width: 142.19,
    height: 69.0406,
    rx: 34.5203,
    transform: "matrix(-1 -2.22734e-09 -2.22734e-09 1 923.608 -9.88074)",
    stroke: "#460FE1",
    strokeWidth: 1.25154
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.409467,
    y: 0.409467,
    width: 93.0406,
    height: 45.176,
    rx: 22.588,
    transform: "matrix(-1 -2.22734e-09 -2.22734e-09 1 794.04 -43.8807)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.409467,
    y: 0.409467,
    width: 45.1811,
    height: 45.176,
    rx: 22.588,
    transform: "matrix(-1 -2.22734e-09 -2.22734e-09 1 810.181 89)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.409467,
    y: 0.409467,
    width: 93.0406,
    height: 45.176,
    rx: 22.588,
    transform: "matrix(-1 -2.22734e-09 -2.22734e-09 1 700.04 -8.88074)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.409467,
    y: 0.409467,
    width: 93.0406,
    height: 45.176,
    rx: 22.588,
    transform: "matrix(-1 -2.22734e-09 -2.22734e-09 1 929.04 72.9999)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.409467,
    y: -0.409467,
    width: 45.1811,
    height: 45.176,
    rx: 22.588,
    transform: "matrix(1 2.22734e-09 2.22734e-09 -1 365 113.176)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.625772,
    y: 0.625772,
    width: 142.19,
    height: 69.0406,
    rx: 34.5203,
    transform: "matrix(-1 -2.22734e-09 -2.22734e-09 1 512.608 -43.8807)",
    stroke: "#460FE1",
    strokeWidth: 1.25154
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.409467,
    y: 0.409467,
    width: 93.0406,
    height: 45.176,
    rx: 22.588,
    transform: "matrix(-1 -2.22734e-09 -2.22734e-09 1 513.04 38.1193)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.409467,
    y: 0.409467,
    width: 93.0406,
    height: 45.176,
    rx: 22.588,
    transform: "matrix(-1 -2.22734e-09 -2.22734e-09 1 289.04 -42.8807)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.409467,
    y: 0.409467,
    width: 93.0406,
    height: 45.176,
    rx: 22.588,
    transform: "matrix(-1 -2.22734e-09 -2.22734e-09 1 627.04 73.1193)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.409467,
    y: -0.409467,
    width: 93.0406,
    height: 45.176,
    rx: 22.588,
    transform: "matrix(1 2.22734e-09 2.22734e-09 -1 66 88.1759)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.625772,
    y: 0.625772,
    width: 142.19,
    height: 69.0406,
    rx: 34.5203,
    transform: "matrix(-1 -2.22734e-09 -2.22734e-09 1 336.191 26.9999)",
    stroke: "#460FE1",
    strokeWidth: 1.25154
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.409467,
    y: 0.409467,
    width: 93.0406,
    height: 45.176,
    rx: 22.588,
    transform: "matrix(-1 -2.22734e-09 -2.22734e-09 1 105.041 -12.8807)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.409467,
    y: 0.409467,
    width: 45.1711,
    height: 45.176,
    rx: 22.5855,
    transform: "matrix(-1 -2.22734e-09 -2.22734e-09 1 65.1711 77.9999)",
    stroke: "#460FE1",
    strokeWidth: 0.818934
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolotas);
export default __webpack_public_path__ + "static/media/bolotas.59c9a35cffaee99dd04539802761f313.svg";
export { ForwardRef as ReactComponent };